const FloorPlansIcon = ({
  alternateIcon = false,
  isActive,
  styles
}: {
  alternateIcon?: boolean;
  isActive?: boolean;
  styles?: any;
}) => {
  if (alternateIcon) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
      >
        <path
          d="M2.91602 11.1159V8.19922C2.91602 5.29422 5.26102 2.94922 8.16601 2.94922H18.0827"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.2488 11.1172V21.0339C26.2488 23.9389 23.9038 26.2839 20.9988 26.2839H11.0822"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0827 26.2839H8.16602C5.26102 26.2839 2.91602 23.9389 2.91602 21.0339V11.1172"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.4466 3.73212L17.605 8.57367C17.4183 8.76034 17.2432 9.12208 17.1966 9.37875L16.9283 11.2337C16.8349 11.8987 17.3016 12.3771 17.9666 12.2721L19.8216 12.0037C20.0782 11.9687 20.4399 11.7821 20.6266 11.5954L25.4683 6.75375C26.2966 5.92541 26.6933 4.94544 25.4683 3.72044C24.2549 2.50711 23.2866 2.89212 22.4466 3.73212Z"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.7589 4.42188C22.1672 5.89187 23.3222 7.03518 24.7922 7.45518"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0822 2.94922V26.2826"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.91602 11.1172H11.0827"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0822 19.2832H26.2488"
          stroke="#015C9A"
          stroke-width="1.53425"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  let color;
  if (isActive === true) {
    color = '#1E4164';
  } else if (isActive === false) {
    color = '#8E8E8E';
  } else {
    color = '#666666';
  }
  return (
    <svg
      style={styles}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.61316 0C7.61316 2.20785 7.61316 4.33589 7.61316 6.54374C16.7897 6.54374 25.9097 6.54374 35.0749 6.54374C35.0749 16.3593 35.0749 26.0685 35.0749 35.8708C34.8823 35.8841 34.6897 35.8974 34.4858 35.8974C24.1537 35.8974 13.8328 35.8974 3.5007 35.8974C1.35949 35.8974 0 34.3014 0 31.7877C0 22.5706 0 13.3402 0 4.12309C0 1.59603 1.35949 0.0133003 3.5007 0C4.83753 0 6.17437 0 7.61316 0ZM34.1006 34.727C34.1006 25.6828 34.1006 16.7184 34.1006 7.76736C25.2526 7.76736 16.4612 7.76736 7.60184 7.76736C7.60184 14.9761 7.60184 22.1184 7.60184 29.3005C7.36392 29.3138 7.17133 29.3404 6.99006 29.3404C5.7212 29.3404 4.46367 29.3271 3.19481 29.3537C1.94861 29.3936 1.01962 30.5108 0.974304 31.934C0.928987 33.5832 1.92595 34.7536 3.44405 34.7536C13.4703 34.7536 23.4853 34.7536 33.5115 34.7536C33.7041 34.7536 33.8854 34.7403 34.1006 34.727ZM6.62753 28.1301C6.63886 27.9838 6.66152 27.8774 6.66152 27.771C6.66152 19.0593 6.66152 10.3476 6.67285 1.63593C6.67285 1.21033 6.52557 1.11722 6.19703 1.11722C5.32468 1.13052 4.46367 1.11722 3.59133 1.11722C1.82399 1.15712 0.974304 2.15464 0.974304 4.25609C0.974304 12.3294 0.974304 20.3893 0.974304 28.4626C0.974304 28.6754 0.996962 28.8882 1.00829 29.2207C2.74165 27.5449 4.73557 28.4759 6.62753 28.1301Z"
        fill={color}
      />
      <path
        d="M12.1332 1.71624C12.1332 1.10443 12.1332 0.599022 12.1332 0.0537109C14.433 0.0537109 16.6875 0.0537109 18.9759 0.0537109C18.9759 0.372917 18.9759 0.692124 18.9759 1.10443C18.7947 1.11773 18.5907 1.14433 18.3982 1.14433C16.8121 1.14433 15.226 1.14433 13.6399 1.15763C13.47 1.15763 13.2887 1.34384 13.1188 1.43694C13.3001 1.53004 13.47 1.71624 13.6513 1.71624C18.2169 1.72955 22.7825 1.74285 27.3482 1.71624C28.1299 1.71624 28.8776 1.80935 29.614 2.14185C30.373 2.47436 31.1547 2.74037 31.9138 3.07287C32.0724 3.13937 32.231 3.41868 32.2423 3.61818C32.2537 3.77779 32.0724 4.04379 31.9251 4.11029C30.8375 4.5625 29.7499 4.97481 28.651 5.40042C28.5151 5.45362 28.3564 5.45362 28.2092 5.45362C22.5446 5.45362 16.8801 5.45362 11.2268 5.45362C10.3205 5.45362 9.66341 4.81521 9.53878 3.85759C9.42549 2.99307 9.87866 2.10195 10.6037 1.82265C10.819 1.74285 11.0456 1.74285 11.2721 1.72955C11.5214 1.70294 11.7819 1.71624 12.1332 1.71624ZM13.1414 4.2699C18.1036 4.2699 23.0091 4.2699 27.892 4.2699C28.1185 2.86007 28.0959 2.83347 26.9516 2.83347C22.5559 2.83347 18.1602 2.83347 13.7645 2.83347C13.5606 2.83347 13.3567 2.83347 13.1301 2.83347C13.1414 3.35218 13.1414 3.79109 13.1414 4.2699ZM12.0992 2.84677C11.5667 2.88667 11.0002 2.58076 10.6151 3.17927C10.5018 3.35218 10.5018 3.84429 10.6264 4.00389C11.0229 4.5492 11.578 4.2566 12.0992 4.2832C12.0992 3.77779 12.0992 3.35218 12.0992 2.84677ZM30.0332 3.68469C30.0332 3.61818 30.0445 3.56498 30.0445 3.49848C29.6933 3.37878 29.3421 3.24578 28.9456 3.11277C28.9456 3.47188 28.9456 3.72459 28.9456 4.07039C29.3421 3.92409 29.682 3.80439 30.0332 3.68469Z"
        fill={color}
      />
      <path
        d="M31.4718 10.3076C31.4718 17.6095 31.4718 24.8448 31.4718 32.1334C24.4137 32.1334 17.3897 32.1334 10.3203 32.1334C10.3203 24.8581 10.3203 17.6095 10.3203 10.3076C17.3557 10.3076 24.3797 10.3076 31.4718 10.3076ZM30.5201 11.4514C24.0739 11.4514 17.6842 11.4514 11.272 11.4514C11.272 13.7391 11.272 15.9735 11.272 18.208C14.3308 18.208 17.3444 18.208 20.4146 18.208C20.4146 16.6651 20.4146 15.1622 20.4146 13.6859C21.3662 13.4997 21.3775 13.513 21.3775 14.5238C21.3775 15.4282 21.3775 16.3459 21.3775 17.2504C21.3775 17.9553 21.3775 18.6469 21.3775 19.4316C17.9448 19.4316 14.6027 19.4316 11.2606 19.4316C11.2606 21.0542 11.2606 22.5971 11.2606 24.1532C13.1073 24.1532 14.8973 24.1532 16.7666 24.1532C16.7666 23.3153 16.7666 22.5306 16.7666 21.7326C17.1065 21.7326 17.3784 21.7326 17.6616 21.7326C17.6616 22.9429 17.6616 24.1133 17.6616 25.3635C15.4977 25.3635 13.3792 25.3635 11.2493 25.3635C11.2493 27.2921 11.2493 29.1142 11.2493 30.9895C15.611 30.9895 19.9274 30.9895 24.2438 30.9895C24.2438 29.0743 24.2438 27.2389 24.2438 25.3236C22.8616 25.3236 21.5248 25.3236 20.1766 25.3236C20.1766 24.9113 20.1766 24.5788 20.1766 24.233C21.876 24.233 23.5301 24.233 25.2634 24.233C25.2634 26.5073 25.2634 28.7551 25.2634 31.0427C26.9628 31.0427 28.5828 31.0427 30.2029 31.0427C30.5428 31.0427 30.5428 30.8033 30.5428 30.5107C30.5428 29.5531 30.5428 28.6088 30.5428 27.6512C30.5428 26.9064 30.5428 26.1482 30.5428 25.3236C29.4665 25.3236 28.4582 25.3236 27.4499 25.3236C27.4499 24.898 27.4499 24.5655 27.4499 24.1665C28.4922 24.1665 29.4892 24.1665 30.5088 24.1665C30.5201 19.937 30.5201 15.7341 30.5201 11.4514Z"
        fill={color}
      />
    </svg>
  );
};

export default FloorPlansIcon;
